import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=85fce604&scoped=true&"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetPage.vue?vue&type=style&index=0&id=85fce604&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fce604",
  null
  
)

export default component.exports